<ng-template #vcrFilter />
@if (filterToDisplay.operator.operator.isRange) {
  @switch (filterToDisplay.column.columnInfo.filterType) {
    @case ('text') {
      <iu-input-text-ui
        [fieldValue]="filterToDisplay.filterTo"
        [isInUniversalFilter]="true"
        [isStandalone]="true"
        (fieldValueModified)="setFilterTo($event)" />
    }
    @case ('number') {
      <iu-input-number-ui
        [fieldValue]="filterToDisplay.filterTo"
        [isInUniversalFilter]="true"
        [isStandalone]="true"
        (fieldValueModified)="setFilterTo($event)" />
    }
    @case ('date') {
      <iu-calendar-ui
        [calendarConfig]="filterToDisplay.configsTo?.calendarConfig || { todayMode: false }"
        [data]="{
          needTime: filterToDisplay.column.columnInfo.fieldEntity.field.AD_Reference_ID === 16,
        }"
        [fieldValue]="
          filterToDisplay.filterTo | toDate: filterToDisplay.column.columnInfo.fieldEntity.field.AD_Reference_ID === 16
        "
        [hasTodayBtn]="true"
        [isInUniversalFilter]="true"
        [isStandalone]="true"
        (calendarConfigChange)="onCalendarConfigChange($event, true)"
        (fieldValueModified)="setFilterTo($event)" />
    }
    @case ('time') {
      <iu-input-time-ui
        [calendarConfig]="filterToDisplay.configsTo?.calendarConfig || { todayMode: false }"
        [fieldValue]="filterToDisplay.filterTo | toDate: true"
        [isInUniversalFilter]="true"
        [isStandalone]="true"
        (calendarConfigChange)="onCalendarConfigChange($event, true)"
        (fieldValueModified)="setFilterTo($event)" />
    }
  }
}
